export const STATE_HAVE_SEEN_LOCATION_PERMISSION_DIALOG = 'STATE_HAVE_SEEN_LOCATION_PERMISSION_DIALOG';
export const STATE_ALLOW_REQUEST_LOCATION_PERMISSION = 'STATE_ALLOW_REQUEST_LOCATION_PERMISSION';